<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template><div>
WELCOME PLACEHOLDER: This component should never be visible. see explanation in the route_is_welcome() function of MainView.vue
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	components: { },

	data() { return {
	}},

	computed: {
		// ...mapState(['user_info', 'site_config', 'current_sparkl_embed_component']),
		// ...mapGetters(['small_screen', 'signed_in', 'backdoor_login_only']),
	},
	watch: {
	},

	created() {
	},
	
	methods: {
	}
}
</script>

<style lang="scss">
</style>
